import React, { useEffect } from 'react';
import { Spinner } from '@vp/swan';
import { bugtracker } from '@99designs/design-services-common';
import { Request } from '@99designs/graph-utils/types';
import { __, getCurrentCulture } from '@99designs/i18n';
import { useCombinedProjects } from '../hooks/useCombinedProjects';
import { useListingRequestsForUserQuery } from '../queries/ListingRequests.generated';
import { DashboardTabs } from './DashboardTabs';

export const Dashboard: React.FC = () => {
    const { error, past, current, loading: projectsLoading } = useCombinedProjects();

    const locale = getCurrentCulture();
    const requests = useListingRequestsForUserQuery({
        variables: {
            input: { filters: { locale } },
        },
        errorPolicy: 'ignore',
    });

    const draftBriefRequests = (requests.data?.requestsForUser?.filter(
        (request) => request.brief && request.brief.state === 'DRAFT'
    ) ?? []) as Request[];

    useEffect(() => {
        if (error || requests.error) {
            const notifyError = error || requests.error;
            if (notifyError) {
                bugtracker.notify(notifyError);
            }
        }
    }, [error, requests.error]);

    return projectsLoading || requests.loading ? (
        <Spinner accessibleText={__('Loading')} />
    ) : (
        <DashboardTabs
            currentRequests={current}
            pastRequests={past}
            draftRequests={draftBriefRequests}
            projectsError={error}
            requestsError={requests.error}
        />
    );
};
